import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from 'react-router-dom';
import DownloadIcon from '@mui/icons-material/Download';
import {
    Container,
    Typography,
    Grid,
    Card,
    Button,
    Divider,
    Box,
    CardMedia,
    createTheme,
    ThemeProvider,
} from '@mui/material';
import moment from 'moment';
import Footer from '../navbar/Footer';

const recentIndicesData = [
     {
        title: "Indice des Prix à la Consommation des ménages au Burundi, Mois de mai 2025",
        link: "/documents/IndicesPrixConsommation/IPC_MAI_2025.pdf",
        description: "L’inflation en moyenne annuelle du mois de mai 2025 s’élève à +31,6% contre +29,0% le mois d’avril 2025. ",
        date: "2025-05-11",
        datepublication:"2025-06-10",
         image: 'assets/ipc/ipc_1_2025.PNG',
    },
];

function IndiceRecent() {
    const navigate = useNavigate();
    const theme = createTheme({
        palette: {
            primary: {
                main: '#388E3C',
            },
            secondary: {
                main: '#f50057',
            },
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        borderRadius: '8px',
                        textTransform: 'none',
                        fontWeight: 'bold',
                    },
                },
            },
            MuiCard: {
                styleOverrides: {
                    root: {
                        transition: 'transform 0.2s ease-in-out',
                        '&:hover': {
                            transform: 'scale(1.03)',
                            boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.1)',
                        },
                    },
                },
            },
        },
    });

    return (
        <ThemeProvider theme={theme}>
            <div style={{ backgroundColor: '#f0f4f8', paddingBottom: '20px' }}>
                <NavigationBar />
                <Container maxWidth="lg" style={{ paddingTop: '60px' }}>
                    <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main }}>
                         Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) Récent
                    </Typography>
                    <Divider style={{ margin: '20px 0' }} />

                    <Grid container spacing={1} style={{ marginTop: '10px' }}>
                        {recentIndicesData.map((indice, index) => (
                            <Grid item xs={12} sm={6} md={12} key={index}>
                                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
                                    <Box sx={{ display: 'flex' }}>
                                        <CardMedia
                                            component="img"
                                            sx={{ width: 151, height: 200, m: 2, cursor: 'pointer' }}
                                            image={indice.image}
                                            alt={indice.title}
                                            onClick={() => window.open(indice.link, '_blank')}
                                        />
                                        <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                                            <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main }}>
                                                <a
                                                    href={indice.link}
                                                    style={{ textDecoration: 'none', color: 'inherit' }}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {<DownloadIcon />}{indice.title}
                                                </a>
                                            </Typography>
                                            <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                                                {indice.description}
                                            </Typography>
                                            <Typography variant="caption" color="textSecondary">
                                                {moment(indice.date).format('MMMM YYYY')}
                                            </Typography>
                                            <Typography variant="caption" color="textSecondary">
                                                Publié le : {moment(indice.datePublication).format('DD/MM/YYYY')}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>

                    <Box display="flex" justifyContent="flex-start" alignItems="center">
                        <Button
                            onClick={() => navigate('/indicesPrixConsommation')}
                            style={{
                                marginBottom: '30px',
                                marginTop: '30px',
                                backgroundColor: theme.palette.primary.main,
                                color: 'white',
                            }}
                        >
                            <ArrowForwardIcon style={{ marginRight: '8px' }} />
                            Aller à la page des Indices
                        </Button>
                    </Box>
                </Container>
                <Footer />
            </div>
        </ThemeProvider>
    );
}

export default IndiceRecent;